import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import convertUserInfo from '@/utils/convertUserInfo'
import fetchAccountData from '@/utils/fetchAccountData'
import GuestTemporaryInput from '@/utils/GuestTemporaryInput'

export default {
  props: {
    regist: { type: String, default: '' },
    action: { type: String, default: '' },
    returnPass: { type: String, default: '' },
    reissueKey: { type: String, default: '' }
  },
  data() {
    return {
      errorMessage: '',
      isLoading: false,
      token: window.Laravel.csrfToken
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    ...mapGetters(['isLoggedIn'])
  },
  mounted() {
    // 認証メールのURL
    if (this.regist == "1") {
      this.loginByReissueKey()
    // 仮登録からの自動ログイン
    } else if (this.regist == "2") {
      this.loginPreUserWithNonce()
    }
  },
  methods: {
    getFirebaseTokenByNonce() {
      return this.$store.dispatch(type.GET_TOKEN_BY_NONCE, this.auth.nonce)
    },
    /**
     * ログイン失敗時( 一連の処理でrejectとなった場合 )の処理
     * - エラーメッセージの表示
     * - storeからログイン情報を削除する
     */
    onFirebaseLoginError(error) {
      if (error) {
        this.errorMessage = error.message
      }

      this.$message({
        message: error.message,
        type: 'error'
      })

      // ログアウト処理を行う
      this.$store.dispatch(type.LOGOUT)
      this.$emit('loginFailure')
      localStorage.clear()
      sessionStorage.clear()
      throw new Error(error)
    },
    loginByFirebaseUid(data) {
      this.isLoading = true
      this.$uid = data.uid
      this.$store
        .dispatch(type.LOGIN_BY_FIREBASE_UID, data)
        .then(this.getFirebaseTokenByNonce)
        .then(this.setTokenToModuleForFirebase)
        .then(this.onFirebaseLoginSuccess)
        .then(this.redirectFirebaseLogin)
        .catch(this.onFirebaseLoginError)
        .finally(() => {
          this.isLoading = false
        })
    },
    registrationByFirebaseUid(data) {
      this.isLoading = true
      this.$uid = data.uid
      this.$store
        .dispatch(type.REGISTRATION_BY_FIREBASE_UID, data)
        .then(this.getFirebaseTokenByNonce)
        .then(this.redirectToSnsLogin)
        .catch(this.onFirebaseLoginError)
        .finally(() => {
          this.isLoading = false
        })
    },
    redirectToSnsLogin(){
      location.href = `/user/sns/input?login_key=` + this.auth.nonce
      //location.href = `/user/sns/input?login_key=` + this.$uid
      this.$emit('loginSucceed')
    },
    setTokenToModuleForFirebase() {
      const data = {
        reissue_key: this.$uid,
        access_token: this.auth.accessToken
      }
      return this.$store.dispatch(type.POST_ACCESS_TOKEN, data)
    },
    onFirebaseRegistSuccess() {
      this.errorMessage = ''
      this.$message({
        message: '連携に成功しました。',
        type: 'success'
      })
    },
    onFirebaseLoginSuccess() {
      this.errorMessage = ''
      if (location.pathname.match(/definitive/) || location.pathname.match(/firstcome\/regist/)) {
      } else {
        // action属性がある場合はsubmit処理を行う
        this.$message({
          message: 'ログインに成功しました。',
          type: 'success'
        })
      }
    },
    redirectToInputNickname(){
      location.href = `/user/sns/input?login_key=` + this.$uid
      // ゲスト入力情報を破棄
      GuestTemporaryInput.clear()
      this.$emit('loginSucceed')
    },
    redirectFirebaseLogin() {
      location.href = `/user/firebase/login?login_key=` + this.$uid
      // ゲスト入力情報を破棄
      GuestTemporaryInput.clear()
      this.$emit('loginSucceed')
    },
    deleteFirebaseRelation(data) {
      const param = {
        access_token: data.accessToken
      }
      var user = firebase.auth().currentUser;
      // console.log(user);
      if(user)user.delete().then(function() {
        // console.log('delete')
        // User deleted.
      }).catch(function(error) {
        // An error happened.
      });
      this.$store
        .dispatch(type.DELETE_FIREBASE_UID, param)
        .then(this.onDeleteRelationSuccess)
        .catch(this.onRelationError)
    },
    /**
     * アクセストークンとuidを渡して
     * アカウントサーバー側でリレーションレコードを作成する
     */
    relationWithFirebaseUid(data) {
      const param = {
        uid: data.uid,
        access_token: data.accessToken,
        sns: data.sns,
        nickname: data.nickname
      }
      this.$store
        .dispatch(type.RELATION_FIREBASE_UID, param)
        .then(this.onRelationSuccess)
        .catch(this.onRelationError)
    },

    /**
     * 連携成功時の処理
     *
     */
    onRelatuonSuccess() {
      this.$message({
        message: 'SNS連携に成功しました',
        type: 'success'
      })
    },
    /**
     * 連携失敗時の処理
     * - エラーメッセージの表示
     */
    onRelationError(error) {
      this.$message({
        message: error.message,
        type: 'error'
      })
      throw new Error(error)
    },
    onDeleteRelationSuccess() {
      this.$message({
        message: 'SNS連携を解除しました',
        type: 'success'
      })
    },
    /**
     * 仮登録ログイン用
     */
    loginPreUserWithNonce() {
      this.$store
        .dispatch(type.GET_TOKEN_BY_NONCE, this.nonce)
        .then(this.setTokenToModule)
        .then(this.onLoginSuccess)
        .catch(this.onLoginError)
        .finally(() => {
          this.isLoading = false
        })
    },
    setTokenToModule() {
      const data = {
        reissue_key: this.reissueKey,
        access_token: this.auth.accessToken
      }
      return this.$store.dispatch(type.POST_ACCESS_TOKEN, data)
    },
    loginByReissueKey() {
      this.$store
        .dispatch(type.GET_TOKEN_BY_REISSUE_KEY, this.reissueKey)
        .then(this.setTokenToModule)
        .then(this.onLoginSuccess)
        .catch(this.onLoginError)
    },
    onLoginSuccess() {
      // ゲスト入力情報を破棄
      GuestTemporaryInput.clear()
      this.$emit('loginSucceed')
    },
    onLoginError(error) {
      if (error) {
        this.errorMessage = error.message
      }
      this.$message({
        message: 'ログインできませんでした。',
        type: 'error'
      })

      // ログアウト処理を行う
      this.$store.dispatch(type.LOGOUT)
      this.$emit('loginFailure')
      localStorage.clear()
      sessionStorage.clear()
      throw new Error(error)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/firebaselogin.js